
import { Base } from '../base-component';

import './calculator-modals.component.scss';
import { CalculatorService } from 'services/calculator.service';
import { AnalyticsService } from 'services/analytics.service';

import * as $ from 'jquery';

export class CalculatorModals extends Base {

	modals: Element[];
	modalLinks: Element[];
	activeModal: Element;
	closeButton: Element;

	calculatorReset: Element[];
	calculatorFields: Element[];
	calculatorSubmit: Element[];
	calculatorUseExpenses: Element[];
	calculator: HTMLFormElement;
	calculatorOutput: Element[];
	calculatorService: CalculatorService;

	constructor(element: Element, analyticsService: AnalyticsService) {
		super(element);
		this.event.register('openModal', this, this.openModal.bind(this));
	}

	init() {

		this.modals = Array.from(this.element.querySelectorAll('.js-calculator-modal'));
		this.modalLinks = Array.from(document.querySelectorAll('.js-calculator-modal-open'));
		this.closeButton = this.element.querySelector('.js-calculator-modal-close');

		this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculator-reset'));
		this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-calculate'));
		this.calculator = this.element.querySelector('form') as HTMLFormElement;
		if (this.calculator) {
			this.calculatorFields = Array.from(this.calculator.querySelectorAll('input'));
		}
		this.calculatorOutput = Array.from(document.querySelectorAll('.calculator-modals__total'));

		this.calculatorUseExpenses = Array.from(this.element.querySelectorAll('.js-calculator-use-expenses'));

	}

	bindEvents() {

		let totalExpenses: number = 0;

		this.modals.map((item) => item.addEventListener('click', (event) => {
			this.isClickOutsideModal(event);
		}));

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openModals(event);
		}));

		this.calculatorSubmit.map((item) => item.addEventListener('click', (event) => {
			const service = this.calculatorService;
			totalExpenses = 0;
			this.calculatorFields.map((itemField: any) => {
				if (itemField.value === null || itemField.value === undefined || itemField.value === '') {
					totalExpenses += 0;
				} else {
					totalExpenses += parseFloat(itemField.value);
				}
			});
			[].slice.call(this.calculatorOutput).forEach(function (div) {
				div.innerHTML = service.formatter(totalExpenses);
			});
			// Trigger form Complete when the user calculates the results
			this.analyticsService.dtmFormComplete("complete", "");

		}));

		this.calculatorUseExpenses.map((item) => item.addEventListener('click', (event) => {
			event.preventDefault();
			let fieldExpense = Array.from(document.querySelectorAll('input[name=monthly_expenses]'));
			fieldExpense.map((item: any) => {
				item.value = totalExpenses;
			});
			this.closeModal();
		}));
		if (this.closeButton) {
			this.closeButton.addEventListener('click', (event) => this.closeModal());
		}

		this.calculatorReset.map((item) => item.addEventListener('click', (event) => {
			this.resetInputs(event);
		}));

	}

	isClickOutsideModal(event) {

		if (event.target === this.activeModal) {
			this.closeModal();
		}

	}

	openModals(event) {

		let element = event.target;
		let modalId = element.getAttribute('data-modal');
		if (modalId === undefined || modalId === '' || modalId === null) {
			let parentElement = $(element).closest('.js-calculator-modal-open');
			modalId = parentElement.attr('data-modal');
		}
		this.activeModal = this.getModalById(modalId);
		this.openModal();

	}

	closeModal() {

		this.activeModal.classList.add('modal--close');

		setTimeout(() => {
			this.activeModal.classList.add('modal--closed');
		}, 250);

	}

	openModal() {
		this.activeModal.classList.remove('modal--close');
		this.activeModal.classList.remove('modal--closed');
	}

	getModalById(id) {
		return this.element.querySelector(`#${id}`);
	}

	resetInputs(event) {
		event.preventDefault();
		this.calculator.reset();
		[].slice.call(this.calculatorOutput).forEach(function (div) {
			div.innerHTML = '0';
		});
		//Analytics - allow user to trigger a new form start on next interaction
		this.analyticsService.dtmRestartForm();
	}

}



// WEBPACK FOOTER //
// ./components/calculator-modals/calculator-modals.component.ts